<style lang="scss" scoped></style>

<template>
  <td>
    <v-button
      @click.native="remove()"
      class="btn-primary"
      :disabled="isDeleted"
      :working="loading"
    >
      {{ label || "Löschen" }}
    </v-button>
  </td>
</template>

<script lang="babel">
export default {
    props: ['attribute', 'content', 'label', 'model'],
    data() {
      return {
        loading: false
      };
    },
    methods: {
      remove() {
        let text = this.attribute.text ? this.attribute.text : 'Sicher?';
        let confirmed = confirm(text);
        if (!confirmed) {
          return;
        }
        let url = this.content ? this.content : this.model.delete_url;
        this.loading = true;
        this.$store.dispatch(`${this.resource}/delete`, { url: url, id: this.model.id})
          .then(() => {
            let notifcation = this.attribute.notification
              ? this.attribute.notification
              : 'Artikel wurde gelöscht';
            this.$notify({
              title: notifcation,
              type: "success"
            });
            this.$emit('table-update', { count: true });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    computed: {
      resource() {
        const url = this.model.delete_url.split('/');

        return url[url.length - 2];
      },
      isDeleted() {
        return Boolean(this.model.deleted_at);
      }
    }
};
</script>
